import React/*, { Component }*/ from 'react';
import {/*Container,*/Row, Col} from 'reactstrap';

class DebugHelperElement extends React.Component{

    render(){
        if(this.props.search.indexOf("showResults=true") === -1){
            return <div/>
        }

        console.log(this.props.mode.getExercise().getResultAtIndex(this.props.index).getValue());
        return <Row>
            <Col xs={{size:8, offset: 2}} style={{border: "2px solid black", "paddinTop": "20px"}}>
                Result&nbsp;
                {this.props.mode.getExercise().getResultAtIndex(this.props.index).getValue()}
            </Col>
        </Row>
    }
}
export default DebugHelperElement